export default __webpack_public_path__ + "static/media/image-square-3.d79b8887.jpg";